module.exports = __webpack_public_path__ + "static/img/dd-partner-08.9b6ed03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-partner-08.jpg
// module id = cSM5
// module chunks = 1